import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { Box, Button, styled } from '@mui/material';

export const StyledButton = styled(Button)({
  minWidth: 0,
  padding: 4,
  lineHeight: '16px',
  height: 20,
  width: 20,
  '& svg': {
    fontSize: 20,
  },
  '&:hover': {
    backgroundColor: spaceCadet[100],
    color: spaceCadet[700],
  },
  '&.active': {
    color: ultraMarine[500],
  },

});

const StyledBox = styled(Box)({
  position: 'sticky',
  top: 0,
  display: 'flex',
  padding: 8,
  gap: 6,
  borderBottom: `solid 1px ${spaceCadet[300]}`,
  '& .MuiBox-root.subcategory': {
    display: 'flex',
    gap: 0,
  },
});

export default StyledBox;
